/**
 * this file contains all variable stored in the local storage
 */

export const STORAGE = {
    USER_TOKEN: "mIZWsYFClS", //user_token
    SESSION_TIME: "KLlXoZeBxI", //session_time
  };
